<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-account-hard-hat"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingMachine"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:250"
                          name="router.name"
                        >
                          <v-text-field
                            v-model="router.name"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.router.name')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:12"
                          name="router.nip"
                        >
                          <v-text-field
                            v-model="router.nip"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.router.nip')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules=""
                          name="router.userId"
                        >
                          <v-select
                            v-model="router.userId"
                            :items="users"
                            item-text="userName"
                            item-value="id"
                            :label="$t('fields.router.userId')"
                            :error-messages="errors"
                            outlined
                            :loading="usersLoading"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="max:20"
                          name="router.cellPhone"
                        >
                          <v-text-field
                            v-model="router.cellPhone"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.router.cellPhone')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="max:250"
                          name="router.email"
                        >
                          <v-text-field
                            v-model="router.email"
                            outlined
                            name="router.email"
                            :label="$t('fields.router.email')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="cancel"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <base-material-snackbar
      v-model="showSuccessAlert"
      :dismissible="false"
      type="success"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['timeout']: 1000
      }"
    >
      <span class="text-uppercase">{{ $t('success') }} :</span>
    </base-material-snackbar>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const personsRespository = repositoryFactory.get('persons')
  const usersRespository = repositoryFactory.get('users')

  export default {
    inject: ['theme'],
    name: 'RouterCrud',
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      router: {},
      showErrorMessage: false,
      errorMessage: '',
      loadingMachine: false,
      showSuccessAlert: false,
      formAction: null,
      usersLoading: false,
      users: [],
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-router') : this.$t('modify-router')
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingMachine = true
        var id = this.$route.params.id
        personsRespository.getById(id).then(response => {
          self.loadingMachine = false
          self.router = Object.assign({}, response.data.data)
          this.getUsers()
        }).catch(err => {
          self.loadingMachine = false
          alert(err)
        })
      } else {
        self.getUsers()
      }
    },
    methods: {
      submitForm (scope) {
        var self = this
        var data = {
          data: this.router,
        }
        data.data.typeCode = 'ROT'

        if (self.formAction !== 'add') {
          personsRespository.updatePerson(data, this.router.id).then(response => {
            if (response.data.isValid) {
              self.showSuccessAlert = true
              self.getUsers()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
          })
        } else {
          personsRespository.addPerson(data).then(response => {
            if (response.data.isValid) {
              self.router = response.data.data
              self.showSuccessAlert = true
              self.formAction = 'modify'
              self.getUsers()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
          })
        }
      },
      getUsers () {
        var self = this
        self.usersLoading = true
        var userId = self.router.userId === undefined || self.router.userId == null ? '' : self.router.userId
        usersRespository.getUsersWithOutPerson(userId).then(response => {
          self.users = response.data.data
          self.usersLoading = false
        }).catch(err => {
          self.usersLoading = false
          alert(err)
        })
      },
      cancel () {
        this.$router.push({ name: 'routers' })
      },
    },
  }
</script>
